/** Copy PNG files into apps/web/public/assets/crops/ */
const ICONS: Record<string, string> = {
  SILPHIUM: 'silphium',
  MISCANTHUS: 'miscanthus',
  CLOVER: 'clover',
  KLEE: 'clover',
  ALFALFA: 'alfalfa',
  LUZERNE: 'alfalfa',
  FIELDGRASS: 'fieldgrass',
  ACKERGRAS: 'fieldgrass',
  VETCHRYE: 'vetchrye',
  WICKROGGEN: 'vetchrye',
  CLOVERGRASS: 'clovergrass',
  KLEEGRAS: 'clovergrass',
  SUNHEMP: 'sunhemp',
  SONNENHANF: 'sunhemp',
  COVERCROP: 'covercrop',
  ZWISCHENFRUCHT: 'covercrop',
  PHACELIA: 'phacelia',
  MUSTARD: 'mustard',
  SENF: 'mustard',
  OILSEEDRADISH: 'oilseedradish',
  OELRETTICH: 'oilseedradish',
  FODDERBEET: 'fodderbeet',
  FUTTERRUEBE: 'fodderbeet',
  CHINESECABBAGE: 'chinesecabbage',
  CHINAKOHL: 'chinesecabbage',
  LETTUCE: 'lettuce',
  SALAT: 'lettuce',
  TOMATO: 'tomato',
  TOMATEN: 'tomato',
  STRAWBERRY: 'strawberry',
  ERDBEEREN: 'strawberry',
  ONION: 'onion',
  ZWIEBELN: 'onion',
  GARLIC: 'garlic',
  KNOBLAUCH: 'garlic',
  CHILI: 'chili',
  OYSTERMUSHROOM: 'oystermushroom',
  AUSTERNPILZ: 'oystermushroom',
  ENOKI: 'enoki',
  ONIONGRASS: 'oniongrass',
  ZWIEBELGRAS: 'oniongrass',
  TRITICALE: 'triticale',
  SPELT: 'spelt',
  DINKEL: 'spelt',
  EMMER: 'emmer',
  EINKORN: 'einkorn',
  RYE: 'rye', ROGGEN: 'rye',
  POPLAR: 'poplar', POPLARS: 'poplar', PAPPEL: 'poplar', PAPPELN: 'poplar',
  POPPY: 'poppy', MOHN: 'poppy',
  HEMP: 'hemp', HANF: 'hemp',
  WHEAT: 'wheat', WEIZEN: 'wheat',
  BARLEY: 'barley', GERSTE: 'barley',
  OAT: 'oat', HAFER: 'oat',
  CANOLA: 'canola', RAPE: 'canola', RAPS: 'canola',
  SORGHUM: 'sorghum',
  MAIZE: 'maize', CORN: 'maize', MAIS: 'maize',
  SUGARBEET: 'sugarbeet', SUGAR_BEET: 'sugarbeet', ZUCKERRUEBEN: 'sugarbeet',
  POTATO: 'potato', POTATOES: 'potato', KARTOFFELN: 'potato',
  GRASS: 'grass', GRAS: 'grass',
  COTTON: 'cotton', BAUMWOLLE: 'cotton',
  SUNFLOWER: 'sunflower', SONNENBLUMEN: 'sunflower',
  SUGARCANE: 'sugarcane', ZUCKERROHR: 'sugarcane',
  OLIVE: 'olive', OLIVES: 'olive', OLIVEN: 'olive',
  GRAPE: 'grape', GRAPES: 'grape', TRAUBEN: 'grape',
  CARROT: 'carrot', CARROTS: 'carrot', KAROTTEN: 'carrot',
  PARSNIP: 'parsnip', PARSNIPS: 'parsnip', PASTINAKEN: 'parsnip',
  REDBEET: 'redbeet', BEETROOT: 'redbeet', ROTE_BEETE: 'redbeet',
  PEA: 'pea', PEAS: 'pea', ERBSEN: 'pea',
  SPINACH: 'spinach', SPINAT: 'spinach',
  GREENBEAN: 'greenbean', GREEN_BEAN: 'greenbean', BUSCHBOHNEN: 'greenbean',
  SOYBEAN: 'soybean', SOYBEANS: 'soybean', SOJABOHNEN: 'soybean',
  LONGGRAINRICE: 'longgrainrice', LONG_GRAIN_RICE: 'longgrainrice', LANGKORNREIS: 'longgrainrice',
  RICE: 'rice', REIS: 'rice',
};

export function cropIconUrl(crop: string | null | undefined): string | null {
  if (!crop) return null;
  const key = crop.trim().toUpperCase().replace(/[\s-]+/g, '_');
  const file = ICONS[key] ?? ICONS[key.replace(/_/g, '')];
  return file ? `/assets/crops/${file}.png` : null;
}
